<template>
  <div :class="$style.box">
    <header :class="$style.banner"></header>
    <p>完成每日游戏内首充任务，即可参与当天抢券/抢手办活动。</p>
    <div :class="$style.content">
      <div :class="$style.item">
        <p>第一步</p>
        <p>绑定游戏账号</p>
        <div
          :class="$style.accomplish"
          :style="{ backgroundImage: `url(${$cdnUrl}/seckill/main/daily/renwu_icon1.png)` }"
        >
          <div v-if="isBindAccount">
            <img :src="`${$cdnUrl}/seckill/main/daily/renwu_yibangding.png`" />
            <img :src="`${$cdnUrl}/seckill/main/daily/renwu_yiwancheng.png`" />
          </div>
          <div v-else @click="handleBindAccount">
            <img :src="`${$cdnUrl}/seckill/main/daily/renwu_weibangding.png`" />
            <img :src="`${$cdnUrl}/seckill/main/daily/renwu_weiwancheng.png`" />
          </div>
        </div>
      </div>
      <img :src="`${$cdnUrl}/seckill/main/daily/renwu_jiantou.png`" />
      <div :class="$style.item">
        <p>第二步</p>
        <p>游戏内完成首充</p>
        <div
          :class="$style.accomplish"
          :style="{ backgroundImage: `url(${$cdnUrl}/seckill/main/daily/renwu_icon2.png)` }"
        >
          <div v-if="isFirstPay">
            <img :src="`${$cdnUrl}/seckill/main/daily/renwu_yichongzhi.png`" />
            <img :src="`${$cdnUrl}/seckill/main/daily/renwu_yiwancheng.png`" />
          </div>
          <div v-else @click="handleFirstPay">
            <img :src="`${$cdnUrl}/seckill/main/daily/renwu_weichizhong.png`" />
            <img :src="`${$cdnUrl}/seckill/main/daily/renwu_weiwancheng.png`" />
          </div>
        </div>
      </div>
      <img :src="`${$cdnUrl}/seckill/main/daily/renwu_jiantou.png`" />
      <div :class="$style.item">
        <p>第三步</p>
        <p>点击开始抢券</p>
        <div
          :class="$style.accomplish"
          :style="{ backgroundImage: `url(${$cdnUrl}/seckill/main/daily/renwu_icon3.png)` }"
          @click="handleSnatch"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import { mapState, mapMutations, mapActions } from 'vuex';

export default {
  props: {
    isBindAccount: {
      type: Boolean,
      default: false
    },
    isFirstPay: {
      type: Boolean,
      default: false
    },
    isActStart: {
      type: Boolean,
      default: true
    },
    selectDate: {
      type: String,
      dafault: ''
    },
    nowTimesTamp: {
      default: ''
    }
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapState('activity', {
      forumAccount: state => state.forumAccount
    }),
    // 显示的是否是当天的代金券列表
    isToday() {
      return dayjs(this.selectDate).isSame(dayjs(this.nowTimesTamp), 'date')
    }
  },
  methods: {
    ...mapMutations('app', {
      CHANGE_SHOW_LOADING: 'CHANGE_SHOW_LOADING'
    }),
    ...mapActions('activity', {
      getForumBindAccount: 'getForumBindAccount',
    }),
    // 点击抢劵按钮
    handleSnatch() {
      this.$emit('handleSnatch')
    },
    // 点击绑定
    handleBindAccount() {
      if (!this.isActStart) {
        this.$toast('当前活动未开始，\n请于4月25日来参加哦！')
        return
      }
      this.CHANGE_SHOW_LOADING(true)
      this.getForumBindAccount().then(() => {
        this.CHANGE_SHOW_LOADING(false)
        if (!this.isBindAccount && this.forumAccount) {
          // 当平台已绑定，活动未绑定的时候弹出首次绑定弹窗
          this.$bus.$emit('openSeckillDialog', 'gameAccountTips')
        } else {
          this.$bus.$emit('openSeckillDialog', 'showBindAccount')
        }
      })
    },
    // 点击首充
    handleFirstPay() {
      if (!this.isActStart) {
        this.$toast('当前活动未开始，\n请于4月25日来参加哦！')
        return
      }
      if (!this.isToday) {
        this.$toast(`${dayjs(this.selectDate).isBefore(dayjs(this.nowTimesTamp), 'date') ? '已过任务时间' : '任务未开始'}！`)
        return
      }
      this.$bus.$emit('openSeckillDialog', 'firstTask')
    },
  },
}
</script>

<style lang='scss' module>
@import '~@/styles/_variable';
.box {
  display: flex;
  flex-direction: column;
  align-items: center;
  .banner {
    width: 90%;
    height: 25px;
    background-image: url('#{$cdn-url-hm}/seckill/main/daily/renwu_biaoti_meirirenwu.png');
    background-size: 100% auto;
    background-repeat: no-repeat;
  }
  > p:first-of-type {
    margin-top: 3px;
    font-size: 9px;
    font-weight: 400;
    color: #ece09b;
    line-height: 14px;
  }
  .content {
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 360px;
    height: 106px;
    margin-top: 8px;
    padding: 0 10px;
    background-image: url('#{$cdn-url-hm}/seckill/main/daily/renwu_dikuang_1meirirenwu.png');
    background-repeat: no-repeat;
    background-size: 100% auto;
    .item {
      width: 76.39px;
      height: auto;
      display: flex;
      flex-direction: column;
      align-items: center;
      > p {
        font-size: 9px;
        font-weight: 400;
        color: #ece09b;
        line-height: 14px;
        text-shadow: 0px 0px 0px rgba(71, 0, 0, 0.65);
      }
      .accomplish {
        width: 88px;
        height: 60px;
        padding-top: 2px;
        background-repeat: no-repeat;
        background-size: 100% auto;
        > div {
          position: relative;
          text-align: center;
          width: 100%;
          height: 100%;
          margin-top: 5px;
          > img:first-child {
            width: 31px;
            height: 9px;
          }
          > img:last-child {
            position: absolute;
            right: 8px;
            bottom: 8px;
            width: 40px;
            height: 23px;
          }
        }
      }
    }
    > img {
      width: 13px;
      height: 9px;
      margin-top: 33px;
    }
  }
}
</style>
